import { parseInterpretation } from './gloss';
import type { InterpretRequest, Interpretation } from './types';

/**
 * Ask the interpreter for one Auslan reply. The API key lives on the server;
 * the browser only ever sees the JSON contract, which is re-validated here
 * before it reaches the UI state machine.
 */
export async function requestInterpretation(
  request: InterpretRequest,
  signal?: AbortSignal,
): Promise<Interpretation> {
  const response = await fetch('/api/interpret', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
    signal,
  });

  if (!response.ok) {
    throw new Error(`interpreter responded ${response.status}`);
  }
  return parseInterpretation(await response.json());
}
